import SmimeMessage from 'owa-smime-adapter/lib/store/schema/SmimeMessage';
import ItemId from 'owa-service/lib/contract/ItemId';
import { action } from 'satcheljs';

const mergeSmimeOnlyProperties = action(
    'mergeSmimeOnlyProperties',
    (itemId: ItemId, smimeMessage: SmimeMessage) => ({
        itemId,
        smimeMessage,
    })
);

export default mergeSmimeOnlyProperties;
